import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import moment from "moment";
import countryList from "react-select-country-list";
import placeholder from "../../assets/images/userprofile.png";
import { blobToFile } from "../../utils/helpers";
import ImageCropper from "../../Component/ImageCropper";
import SkeletonLoader from "../UpdateProfile/skeltonLoader";
import queryString from "query-string";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { getSettingData } from "../../actions/settingActions";
import { getAllProgrammes } from "../../actions/userActions";
import {
  fetchUniversityPartners,
  fetchIndustries,
  fetchProgramStudies,
  fetchRegisterSettings,
  fetchAreas,
  fetchObjectives,
  fetchParticularPrograms,
  fetchLanguages,
  fetchExperience,
  fetchUserData,
  registerUser,
  fetchCoursesCompleted,
  fetchBoardExperienceMentor,
  fetchBoardEntityTypeExperience,
  fetchAccreditedDirector,
  fetchBoardExperienceLevel,
  fetchBoardExperience,
} from "../Authentication/Register/slice/registerSlice";

// Import helper functions
import {
  normalizeStudentSignup3Payload,
  buildStudentSignup3FormData
} from "./helpers/studentSignup3DataHelpers";
import { renderField, renderBoardRolesInline } from "./helpers/studentSignup3FieldRenderers";
import { fetchSettings } from "../../store/slices/settingsSlice";

// Move getCookie function to outer scope
function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}

const StudentSignup3 = (props) => {
  const dispatch = useDispatch();

  // Component-specific loading state to prevent flash
  const [componentReady, setComponentReady] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  let d = new Date();
  d.setMonth(d.getMonth() + 3);
  const nextThreeMonthData = d.toLocaleDateString();
  const location = useLocation();
  const history = useNavigate();
  const { superUserParams } = props;
  const { setting } = useSelector((state) => state.settings);
  const programmes = useSelector((state) => state.programmes);
  const {
    universityPartners: university_partners_list,
    industries: industry_list,
    programStudies: programStudyId,
    registerStepFields,
    areas,
    objectives: objective,
    particularPrograms: particularProgram,
    languages: languageOptions,
    experienceData: userExperience,
    coursesCompleted,
    boardExperienceMentor,
    boardEntityTypeExperience,
    accreditedDirector,
    boardExperienceLevel,
    boardExperience,
  } = useSelector((state) => state.register);

  const [dob, setDob] = useState(null);
  const { register, control, reset, clearErrors, handleSubmit, setValue, trigger, watch, formState, formState: { errors } } = useForm({
    defaultValues: superUserParams,
    mode: 'onSubmit'
  });

  const siteName = setting?.name?.trim() || `Register Now as Mentor or Mentee`;

  useEffect(() => {
    dispatch(fetchSettings());
  }, []);

  useEffect(() => {
    const title = `${siteName} - Register Now as Mentor or Mentee`;
    document.title = title;
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        `Register now with ${setting?.name} as a mentor or mentee to join the domain-specific career mentoring between women leaders and experienced industry leaders.`
      );
  }, [siteName]);

  const queryStringParsed = queryString.parse(location.search);
  const [roleId, setRoleId] = useState('');
  const [checkBox, setCheckBox] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [showDateDiv, setShowDateDiv] = useState("none");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState(nextThreeMonthData);
  const [emailVerifyString, setEmailVerifyString] = useState('');
  const [readOnly] = useState(false);
  const [industryData, setIndustryData] = useState('');

  const [{ alt, src }, setImg] = useState({
    src: placeholder,
    alt: "Upload an Image",
  });
  const [cropImg, setCropImg] = useState("");
  const [cropImgModalShow, setCropImgModalShow] = useState(false);
  const [getLoader, setGetLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const getUserId = localStorage.getItem("userId");
  const [userId, setUserId] = useState(localStorage.getItem("userId"))
  const options = countryList().getData();
  const [country] = useState(options);
  const [userData, setUserData] = useState({});
  const [mainArea, setMainArea] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedObjective, setSelectedObjective] = useState([]);
  const [selectedResume, setSelectedResume] = useState("");
  const [resumeText, setResumeText] = useState("");
  const [experience, setExperience] = useState([]);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [redirectPath, setRedirectPath] = useState(null);
  console.log("", experience, userData);

  const customStyles = {
    menu: (base) => ({
      ...base,
      backgroundColor: "white",
      top: '32px',
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    }),
  };

  const countWords = (text) => {
    return text?.replaceAll('\r\n', '\n')?.length
  };

  const availabilityChecked = watch("availability");

  const registerSetting = (roleId1) => {
    if (!roleId1) return;
    dispatch(fetchRegisterSettings({ roleId: roleId1, stepKey: "step_4" }));
  };

  const getAreasData = () => {
    dispatch(fetchAreas());
  };

  const getObjectiveData = (roleID) => {
    if (!roleID) return;
    dispatch(fetchObjectives(roleID));
  };

  const getProgramStudyId = () => {
    dispatch(fetchProgramStudies());
  };

  const getParticularProgram = () => {
    dispatch(fetchParticularPrograms());
  };

  const getUniversityPartnerList = () => {
    dispatch(fetchUniversityPartners());
  };

  const getIndustryList = () => {
    dispatch(fetchIndustries());
  };

  useEffect(() => {
    getUniversityPartnerList();
    getIndustryList();
    getParticularProgram();
    getAreasData();
    getProgramStudyId();
  }, []);
  const currentYear = new Date().getFullYear();
  const years = Array.from(new Array(currentYear - 1990 + 1), (_, index) => 1990 + index);

  const checkFromDate = (date) => {
    setFromDate(moment(new Date(date)).format("YYYY-MM-DD"));
  };

  const checkToDate = (date) => {
    setToDate(moment(new Date(date)).format("YYYY-MM-DD"));
  };

  const [email, setEmail] = useState(queryStringParsed.email);

  const getLanguageList = () => {
    dispatch(fetchLanguages());
  };

  useEffect(() => {
    if (queryStringParsed.email) setValue('email', queryStringParsed.email)
    getLanguageList()
  }, [queryStringParsed.email, setValue])

  const onSubmit = (data) => {
    const normalizedData = normalizeStudentSignup3Payload({
      data,
      roleId,
      dob,
      email_verify_string: emailVerifyString,
      selectedResume,
    });

    const formData = buildStudentSignup3FormData({
      data: normalizedData,
      registerStepFields,
      selectedFile,
    });

    const terminateProcess = registerStepFields?.[0]?.terminate_process;
    setGetLoader(true);

    dispatch(
      registerUser({
        params: formData,
        roleId,
        userId,
        terminateProcess,
        step: "step_4",
        paramsLogin: {
          email: localStorage.getItem("email"),
          password: localStorage.getItem("password"),
          role_id: roleId,
        },
      })
    )
      .unwrap()
      .then((res) => {
        setGetLoader(false);
        if (!res) return;
        setPopupMessage(res?.message);
        setShowPopup(true);
        setRedirectPath(res.redirectTo);
      })
      .catch((error) => {
        setGetLoader(false);
        setPopupMessage(error?.message || "Registration failed");
        setShowPopup(true);
      });
  };

  const [gender, setGender] = useState("");

  const handlePopupOk = () => {
    setShowPopup(false);

    if (redirectPath) {
      history(redirectPath);
    }
  };

  const handleGender = (value) => {
    setGender(value);
  };

  const [employee, setEmployee] = useState("");

  const setOrganizationPlaceholder = (e) => {
    const value = e.target.value;
    setEmployee(value);
  };

  const showDatePicker = (e) => {
    if (e.target.checked === true) {
      setShowDateDiv("block");
    } else {
      setShowDateDiv("none");
    }
  };

  const getExperienceData = () => {
    dispatch(fetchExperience());
  };

  const handleChange = (item) => {
    getExperienceData()
    setRoleId(item);

    // Fetch board-related data based on role
    if (item === "Mentor" || item === "Mentees") {
      dispatch(fetchCoursesCompleted());
      dispatch(fetchBoardExperience(item));
      dispatch(fetchBoardExperienceLevel(item));
      dispatch(fetchBoardEntityTypeExperience(item));
      dispatch(fetchAccreditedDirector(item));
      dispatch(fetchBoardExperienceMentor("Mentee")); // Always call with "Mentee" for board_entity_type_2
    }
  };

  const handleProgrammesChange = (item) => {
    // Function kept for field renderer compatibility
  };

  useEffect(() => {
    const fetchSettingsAndVerify = async () => {
      try {
        dispatch(getSettingData());
        getCookie("redirectFrom");
        dispatch(getAllProgrammes());


      } catch (error) {
        setPopupMessage(error.message);
        setShowPopup(true);
      }
    };

    fetchSettingsAndVerify();
  }, []);

  const [showPassword, setShowPassword] = useState(true);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };


  const applyUserImage = (user) => {
    if (user?.image) {
      setImg({ src: user.image, alt: "Uploaded Profile Image" });
      setValue("image", user.image, { shouldValidate: false });
      clearErrors("image");
      setSelectedFile(user.image);
      return;
    }

    setImg({ src: placeholder, alt: "Upload an Image" });
    setSelectedFile("");
  };

  const handleResume = (user) => {
    if (user?.resume) {
      setValue("resume", user.resume);
      clearErrors("resume");
    }

    setSelectedResume(user?.resume);
    setResumeText(user?.resume ? user.resume.split("resume/")[1] : "");
  };

  const handleBasicFields = (user) => {
    setEmailVerifyString(user?.email_verify_string);
    setRoleId(user?.role_id);
    setUserId(user?.id);

    setSelectedObjective(user?.objective ? user.objective.split(",") : []);

    getObjectiveData(user?.role_id);
    registerSetting(user?.role_id);
    getExperienceData();

    if (["Mentor", "Mentees"].includes(user?.role_id)) {
      fetchBoardDependencies(user?.role_id);
    }

    setValue("about", user?.about || "");

    if (user?.dob) {
      setValue("dob", user.dob);
      clearErrors("dob");
    }

    setDob(user?.dob);
  };

  const fetchBoardDependencies = (roleId) => {
    dispatch(fetchCoursesCompleted());
    dispatch(fetchBoardExperience(roleId));
    dispatch(fetchBoardExperienceLevel(roleId));
    dispatch(fetchBoardEntityTypeExperience(roleId));
    dispatch(fetchAccreditedDirector(roleId));
    dispatch(fetchBoardExperienceMentor("Mentee"));
  };

  const handleBoardMultiSelectFields = (user) => {
    const fields = [
      "board_entity_type",
      "board_entity_type_2",
      "course_completed",
      "accredited_director",
      "indicate_board_experience_level"
    ];

    for (const field of fields) {
      if (!user?.[field]) continue;

      const values = user[field]
        .split(",")
        .map((id) => Number.parseInt(id.trim()));

      setValue(field, values);
      clearErrors(field);
    }

    if (user?.past_board_roles) {
      const roles = user.past_board_roles.split(",").map((r) => r.trim());
      setValue("past_board_roles", roles);
      clearErrors("past_board_roles");
    }
  };

  const handleSingleSelectBoardFields = (user) => {
    const fields = ["years_of_board_experience"];

    for (const field of fields) {
      const value = user?.[field];

      if (value !== undefined && value !== null && value !== "") {
        setValue(field, value.toString());
        clearErrors(field);
      }
    }
  };

  const handleBoardRolesRepeater = (user) => {
    if (!Array.isArray(user?.board_roles_data)) return;

    const roles = user.board_roles_data.map(({ id, ...role }) => ({
      ...role,
      is_currently_working: !!role.is_currently_working
    }));

    setValue("board_roles", roles);
    clearErrors("board_roles");
  };

  const applyBasicUserData = (user) => {
    const { image, resume, ...rest } = user || {};
    reset(rest);

    handleResume(user);
    handleBasicFields(user);
    handleBoardMultiSelectFields(user);
    handleSingleSelectBoardFields(user);
    handleBoardRolesRepeater(user);
  };

  const applyUserPreferences = (user) => {
    setCheckBox2(!!user?.mf_certified_coach);
    setValue("mf_certified_coach", !!user?.mf_certified_coach);

    if (user?.employee) setEmployee(user.employee);
    if (user?.gender) setGender(user.gender);

    if (user?.my_consent) {
      setValue("my_consent", !!user.my_consent);
      clearErrors("my_consent");
      trigger("my_consent");
    }

    if (user?.mn_open_to_talk !== undefined) {
      setValue("mn_open_to_talk", !!Number(user.mn_open_to_talk));
      clearErrors("mn_open_to_talk");
    }

    if (user?.mn_loking_for_coach !== undefined) {
      setValue("mn_loking_for_coach", !!Number(user.mn_loking_for_coach));
      clearErrors("mn_loking_for_coach");
    }
  };


  const applyDomainsAndResume = (user) => {
    const main = user?.domains ? user.domains.split(",") : [];
    const sub = user?.subareas ? user.subareas.split(",") : [];

    setMainArea(main);
    setSelectedArea(sub);

    setValue("mainArea", main);
    setValue("subarea", sub);
    setValue("domains", main);

    clearErrors("mainArea");
    clearErrors("domains");
  };

  const applyExperienceLevels = (user) => {
    if (!user?.experience_levels) return;

    const ids = user.experience_levels.map(item => item.id);
    setExperience(ids);
    setValue("experience_levels", ids, { shouldDirty: true });
  };

  const applyAvailability = (user) => {
    const isAvailable = user?.user_availability === 2;

    setShowDateDiv(isAvailable ? "block" : "none");
    setValue("availability", isAvailable);

    setValue(
      "from_date",
      isAvailable
        ? checkFromDate(user?.user_availability_check?.start_time)
        : null
    );
    setValue(
      "to_date",
      isAvailable
        ? checkToDate(user?.user_availability_check?.end_time)
        : null
    );
  };

  useEffect(() => {
    const loadUserData = async () => {
      try {
        const res = await dispatch(fetchUserData(getUserId)).unwrap();
        const user = res?.data;

        setUserData(user);

        applyUserImage(user);
        applyBasicUserData(user);
        applyUserPreferences(user);
        applyDomainsAndResume(user);
        applyExperienceLevels(user);
        applyAvailability(user);

        if (localStorage.getItem("student_img")) {
          setSelectedFile(
            blobToFile(localStorage.getItem("student_img"), `${getUserId}.png`)
          );
        }

        setTimeout(() => {
          setComponentReady(true);
          setInitialDataLoaded(true);
        }, 300);
      } catch (err) {
        console.error(err);
      }
    };

    if (getUserId) {
      loadUserData();
    }
  }, [getUserId]);


  useEffect(() => {
    if (userExperience?.length > 0) {
      setExperience(userExperience.map((item) => item.id));
    }
  }, [userExperience]);

  const onChangePicture = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) {
      setImg({ src: placeholder, alt: "Upload an Image" });
      setGetLoader(false);
      return;
    }

    const allowedExtensions = ["jpg", "jpeg", "png"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      setPopupMessage("Please select valid image format (jpg, jpeg, png)");
      setShowPopup(true);
      return;
    }

    // ✅ 30 MB check (STANDARDIZED)
    const sizeInMB = file.size / (1024 * 1024);
    if (sizeInMB > 30) {
      setPopupMessage("Please select image size less than 30 MB");
      setShowPopup(true);
      setImg({ src: placeholder, alt: "Upload an Image" });
      return;
    }

    clearErrors("image");

    setImg({
      src: placeholder,
      alt: file.name,
    });

    setCropImg(URL.createObjectURL(file));
    setCropImgModalShow(true);
    setGetLoader(false);
  };

  const onChangeResume = (e) => {
    if (e.target.files[0]) {
      const selectedResume = e.target.files[0];
      setSelectedResume(selectedResume);
      setResumeText(selectedResume.name);
      clearErrors('resume');
    }
  };

  const fileToImage = (childdata) => {
    setSelectedFile(blobToFile(childdata, getUserId + ".png"));
    setImg({
      src: URL.createObjectURL(childdata),
      alt: "",
    });
    setCropImgModalShow(false);
  };

  useEffect(() => {
    if (selectedObjective.length > 0) {
      setValue("objective", selectedObjective);
      clearErrors("objective");
      trigger("objective");
    }
  }, [selectedObjective, setValue, clearErrors, trigger]);
  // Create dependencies object for field renderers
  const fieldDeps = {
    register,
    errors,
    control,
    setValue,
    trigger,
    clearErrors,
    watch,
    // Text field deps
    email,
    setEmail,
    readOnly,
    // Password field deps
    showPassword,
    togglePasswordVisibility,
    // SingleSelect deps
    handleChange,
    roleId,
    email_verify_string: emailVerifyString,
    programmes,
    programStudyId,
    handleProgrammesChange,
    university_partners_list,
    years,
    userExperience,
    setExperience,
    country,
    languageOptions,
    customStyles,
    industryData,
    setIndustryData,
    industry_list,
    particularProgram,
    // Radio deps
    employee,
    setOrganizationPlaceholder,
    gender,
    handleGender,
    // Checkbox deps
    checkBox,
    setCheckBox,
    checkBox2,
    setCheckBox2,
    // DatePicker deps
    availabilityChecked,
    showDatePicker,
    showDateDiv,
    fromDate,
    toDate,
    checkFromDate,
    checkToDate,
    dob,
    setDob,
    // File deps
    selectedFile,
    src,
    alt,
    onChangePicture,
    resumeText,
    onChangeResume,
    selectedResume,
    // CustomSelect deps
    areas,
    mainArea,
    selectedArea,
    setMainArea,
    setSelectedArea,
    objective,
    selectedObjective,
    setSelectedObjective,
    // Textarea deps
    countWords,
    // Board-related data
    coursesCompleted,
    boardExperienceMentor,
    boardEntityTypeExperience,
    accreditedDirector,
    boardExperienceLevel,
    boardExperience,
    formState,
    // Settings for board_roles_validation
    setting,
  };

  return (
    <div>
      {/* SkeletonLoader - show while component is not ready or data is not loaded */}
      {(!componentReady || !initialDataLoaded) && <SkeletonLoader />}

      {/* Main content - show only when component is ready and data is loaded */}
      <div style={{ display: (componentReady && initialDataLoaded) ? 'block' : 'none' }}>
        <section className="loginouter studentsteps">
          <Container>
            <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
              <Row className="align-items-center justify-content-center">
                <Col md={12}>
                  <div className="logininnerouter">
                    <div className="w-100">
                      <div className="loginlogo text-center mb-5 pb-4">
                        <Link to="/">
                          {setting?.logo_path && <img src={setting?.logo_path} alt="logo"
                          //  style={{ maxWidth: '200px', maxHeight: '59px' }} 
                          />}
                        </Link>
                      </div>

                      {registerStepFields?.map((resp) => {
                        return (
                          <div key={resp.id} className="loginform">
                            <h1>{resp?.step_label}</h1>
                            <div className="steps_signup">
                              <div>
                                <span className="stepcount active">1</span>
                                <span className="stepcount active">2</span>
                                <span className="stepcount active">3</span>
                                <span className="stepcount">4</span>
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              style={{
                                marginTop: "0em",
                                display: "block",
                              }}
                            >
                              <div className="businessboxouter">
                                {(() => {
                                  let renderedBoardRoleFields = new Set();
                                  return (<>{resp?.reg_feilds?.map((field, idx) => {
                                    const boardRoleFieldKeys = ['rep_company_name', 'rep_board_title', 'rep_start_date', 'rep_end_date'];
                                    const isBoardRoleField = boardRoleFieldKeys.includes(field.reg_key);
                                    if (renderedBoardRoleFields.has(field.reg_key)) return null;
                                    if (isBoardRoleField && field.reg_key === 'rep_company_name') {
                                      renderedBoardRoleFields.add('rep_company_name');
                                      renderedBoardRoleFields.add('rep_board_title');
                                      renderedBoardRoleFields.add('rep_start_date');
                                      renderedBoardRoleFields.add('rep_end_date');
                                      return (<React.Fragment key="board_roles_group">{renderBoardRolesInline(resp?.reg_feilds, { ...fieldDeps, setting })}</React.Fragment>);
                                    }
                                    if (isBoardRoleField) return null;
                                    return (<React.Fragment key={field.reg_key}>{renderField(field, fieldDeps)}</React.Fragment>);
                                  })}</>);
                                })()}
                              </div>
                            </div>
                            <div className="form-group mt-3 text-center">
                              <Button
                                className="btn loginsubmit outline me-2"
                                onClick={(e) => {
                                  e.preventDefault();
                                  // Clear All functionality
                                  setMainArea([]);
                                  setSelectedArea([]);
                                  setValue("mainArea", []);
                                  setValue("subarea", []);
                                  setValue("domains", []);
                                  clearErrors("mainArea");
                                  clearErrors("subarea");
                                  clearErrors("domains");
                                  trigger("mainArea");
                                  setSelectedObjective([]);
                                  setValue("objective", []);
                                  clearErrors("objective");
                                  trigger("objective");
                                }}
                                title="Clear All"
                                disabled={getLoader}
                              >
                                Clear All
                              </Button>
                              <Button
                                className="btn loginsubmit nextbtn outline me-2"
                                onClick={(e) => {
                                  e.preventDefault();
                                  history("/registration-step-2");
                                }}
                                disabled={getLoader}
                              >
                                Previous
                              </Button>

                              <button
                                type="submit"
                                className="btn loginsubmit nextbtn ml-2 btn-red"
                                disabled={getLoader}
                              >
                                {registerStepFields?.[0]?.terminate_process === "Yes" ? "Submit" : "Save & Next"}
                              </button>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </Col>
              </Row>
            </Form>
          </Container>
        </section>
      </div>

      {cropImgModalShow && (
        <ImageCropper
          show={cropImgModalShow}
          cropImg={cropImg}
          fileToImage={fileToImage}
          onHide={() => setCropImgModalShow(false)}
          centered
          size="xl"
          className="cropper-modal"
        />
      )}

      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={true}
        staticBackdrop={true}
        onConfirm={handlePopupOk}
      />
    </div>
  );
};

StudentSignup3.propTypes = {
  superUserParams: PropTypes.object,
};

StudentSignup3.defaultProps = {
  superUserParams: {},
};

export default StudentSignup3;